
import {
  ApolloClient,
  createHttpLink,
  from
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { connectApolloClientToVSCodeDevTools } from '@apollo/client-devtools-vscode';
import {
  authUtil,
  configUtil,
  reactiveVariables
} from 'modules/common';

import * as cache from './cache';



const { envName } = configUtil.getConfig();

const httpAuthLink = setContext(async ({ context }) => {
  const accessToken = await authUtil.getAccessToken(); // Always returns a good access token if logged in.

  if (accessToken) {
    return {
      headers: {
        ...context?.headers,
        authorization: `Bearer ${accessToken}`
      }
    };
  }

  return {
    headers: {
      ...context?.headers
    }
  };
});



const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_GRAPHQL_URL
});



const __makeClient = () => {
  if (envName !== 'dev' && envName !== 'prod') {
    console.log('Creating New apollo client');
  }
  // console.log("Creating New apollo client");
  return new ApolloClient({
    link: from([
      httpAuthLink,
      httpLink
    ]),
    connectToDevTools: true,
    cache: cache.init()
  });
};



export const client = __makeClient();
if (configUtil.getConfig().envName === 'devLocal') {
  const devToolsRegistration = connectApolloClientToVSCodeDevTools(client, 'ws://localhost:7095');
}


authUtil.obsChangeAuthStatus.subscribe((value) => {
  if (!value) {
    client.cache.evict({
    });

    client.cache.reset();
  }
  reactiveVariables.isLoggedInVar(value);
});
